// extracted by mini-css-extract-plugin
export default {"table":"ProfessionalsSeen_table__kck3Q","appointment":"ProfessionalsSeen_appointment__B68hh"};